import React, { useState, useEffect, useRef } from "react";
import { useForm } from "react-hook-form";
import { ArborescenceBâtimentaireV3 } from "../actif_arborescence/ArborescenceBâtimentaire";
import { sitesSerivces, usersService, actifsService } from "../../services";
import { createFormDataFromObject } from "../../hooks/useFormData";
import { showToast, Loading, CustomDialog } from "..";
import { Actif, User } from "../../interfaces";
import { Dropdown } from "primereact/dropdown";
import { useQueryClient } from "@tanstack/react-query";
import { ArborescenceBâtimentaireEditActif } from "../actif_arborescence/EditCorrespondanceArborescenceBâtimentaire";
import { AWS_BUCKET_ENV,AWS_BUCKET_NAME } from "../../config/awsParams";
interface ModalEditActifProps {
  actif: Actif;
  modalIsOpenEditActif: boolean;
  closeModalEditActif: () => void;
  setSelectedActif: (newActif: Actif) => void;
}
const ModalEditActif = ({
  actif,
  modalIsOpenEditActif,
  closeModalEditActif,
  setSelectedActif,
}: ModalEditActifProps) => {

  const queryClient = useQueryClient();
  const [loading, setLoading] = useState<boolean>(false);
  const [selectedFile, setSelectedFile] = useState(null);
  const fileInputRef = useRef<HTMLInputElement | null>(null);
  const [picture, setPicture] = useState(null);
  const [selectedOption, setSelectedOption] = useState(null);
  const [options, setOptions] = useState([]);
  const [users, setUsers] = useState([]);
  const [activeIndex, setActiveIndex] = useState(0);
  const [site, setSite] = useState(null);
  const [selectedInterlocuteur, setSelectedInterlocuteur] =
    useState<User | null>(actif.interlocuteur_referent);
  const [selectedBâtiments, setSelectedBâtiments] = useState(
    actif?.bâtiments.map((batiment) => batiment.id)
  );
  const [selectedNiveaux, setSelectedNiveaux] = useState(
    actif?.niveaux.map((niveau) => niveau.id)
  );
  const [selectedEspaces, setSelectedEspaces] = useState(
    actif?.espaces.map((espace) => espace.id)
  );
  const [selectedPieces, setSelectedPieces] = useState(
    actif?.pieces.map((piece) => piece.id)
  );

  const { register, handleSubmit, setValue, reset } = useForm();

  useEffect(() => {
    const fetchUsers = async () => {
      try {
        const response = await usersService.getAll();
        setUsers(response);
      } catch (e) {
        console.log("Error while fetching", e);
      }
    };

    fetchUsers();
  }, []);

  useEffect(() => {
    setOptions(users);
  }, [users, actif, setSelectedOption]);

  useEffect(() => {
    if (actif) {
      Object.keys(actif).forEach((key) => {
        setValue(key, actif[key]);
      });
    }
  }, [actif, setValue]);

  useEffect(() => {
    const fetchSiteApi = async (id) => {
      try {
        const response = await sitesSerivces.getById(id);
        setSite(response);
      } catch (e) {
        console.log("Error while fetching", e);
      }
    };
    fetchSiteApi(actif?.site_id);
  }, [actif]);

  const customTabTemplate = (item) => (
    <button
      type="button"
      onClick={() => {
        setActiveIndex(items.indexOf(item));
      }}
      className={`inline-flex items-center px-32 py-2 text-sm font-semibold text-gray-900 bg-transparent border ${
        items.indexOf(item) === activeIndex
          ? "rounded-l-lg hover:bg-gexpertise-200 hover:text-white focus:z-10 focus:ring-2 focus:ring-gexpertise-200 focus:bg-gexpertise-200 focus:text-white"
          : "rounded-r-lg"
      }`}
    >
      {item.label}
    </button>
  );

  const items = [
    {
      label: "Société",
      template: customTabTemplate,
    },
    {
      label: "Individu",
      template: customTabTemplate,
    },
  ];

  const handleFileChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    const file = event.target.files[0];
    setSelectedFile(URL.createObjectURL(file));
    setPicture(file);
  };

  const handleButtonClick = () => {
    if (fileInputRef.current) {
      fileInputRef.current.click();
    }
  };

  const handleSelectChange = (e) => {
    setSelectedInterlocuteur(e.value);
  };

  const onSubmit = async (data) => {
    const actifEditData = {
      ...(picture !== null ? { file: picture } : {}),
      nom_actif: data.nom_actif,
      numero_taxe:data.numero_taxe,
      ...(data.class_principale_actif !== undefined &&
      data.class_principale_actif !== ""
        ? { class_principale_actif: data.class_principale_actif }
        : {}),
    };
    const formData = createFormDataFromObject(actifEditData);
    setLoading(true);
    await actifsService.update(actif?.id, formData);
    const correspondanceData = {
      actif_id: actif.id,
      site_id: actif?.site_id,
      batiment_ids: selectedBâtiments,
      niveau_ids: selectedNiveaux,
      espace_ids: selectedEspaces,
      piece_ids: selectedPieces,
    };
    await actifsService.correspondanceActif(correspondanceData);
    setLoading(false);
    showToast("success", "Actif modifié avec succès");
    queryClient.refetchQueries({
      queryKey: ["actifs"],
    });

    closeModalEditActif();
    window.location.reload();
  };

  const interlocuteurOptionTemplate = (option: User) => {
    return (
      <div className="flex space-x-2">
        <img
          className="object-cover w-8 h-8 rounded-full"
          src={
            option?.photo_user
              ? `https://${AWS_BUCKET_NAME}.s3.amazonaws.com/${AWS_BUCKET_ENV}/users_photos/${option?.photo_user}`
              : `https://${AWS_BUCKET_NAME}.s3.amazonaws.com/${AWS_BUCKET_ENV}/users_photos/profile.png`
          }
        />
        <div className="text-left rtl:text-right">
          <h1 className="text-md font-semibold text-gray-700 capitalize ">
            {option?.first_name + " " + option?.last_name}
          </h1>
        </div>
      </div>
    );
  };
  const selectedInterlocuteurTemplate = (option: User, props) => {
    if (option) {
      return (
        <div className="flex space-x-2">
          <img
            className="object-cover w-8 h-8 rounded-full"
            src={
              option?.photo_user
                ? `https://${AWS_BUCKET_NAME}.s3.amazonaws.com/${AWS_BUCKET_ENV}/users_photos/${option?.photo_user}`
                : `https://${AWS_BUCKET_NAME}.s3.amazonaws.com/${AWS_BUCKET_ENV}/users_photos/profile.png`
            }
          />
          <div className="text-left rtl:text-right">
            <h1 className="text-md font-semibold text-gray-700 capitalize ">
              {option?.first_name + " " + option?.last_name}
            </h1>
          </div>
        </div>
      );
    }

    return <span>{props.placeholder}</span>;
  };

  return (
    <>
      <CustomDialog
        header="Modifier actif"
        visible={modalIsOpenEditActif}
        closeModalDialog={() => {
          closeModalEditActif();
          setSelectedActif(null);
          reset();
        }}
      >
        <div className="w-full h-full ">
          <div className="p-6 space-y-6">
            <form
              onSubmit={handleSubmit(onSubmit)}
              encType="multipart/form-data"
            >
              <div className="grid grid-cols-6 gap-6 mb-2">
                <div className="col-span-3 sm:col-span-3">
                  <label
                    htmlFor="nom_niveau"
                    className="block text-sm font-bold leading-6 text-gray-900"
                  >
                    Nom *
                  </label>
                  <input
                    type="text"
                    name="nom_actif"
                    id="nom_actif"
                    placeholder="Saisir nom"
                    className="  my-3 border border-gray-300 text-gray-900 font-normal text-md rounded-lg focus:ring-gexpertise-100 focus:border-gexpertise-200 block w-full p-2.5 "
                    {...register("nom_actif")}
                  />
                </div>
                <div className="col-span-3 sm:col-span-3">
                  <label
                    htmlFor="picture"
                    className="block text-sm font-bold leading-6 text-gray-900"
                  >
                    Photo
                  </label>
                  <div className="flex space-x-3 mt-5">
                    <div>
                      <div className="w-20 h-20">
                        <img
                          src={
                            selectedFile
                              ? selectedFile
                              : actif?.photo_actif
                              ? `https://${AWS_BUCKET_NAME}.s3.amazonaws.com/${AWS_BUCKET_ENV}/actif_photos/${actif.photo_actif}`
                              : "/images/default_actif.png"
                          }
                          alt="photo actif"
                          className="w-full h-full rounded-lg object-cover"
                        />
                      </div>

                      <input
                        type="file"
                        id="picture"
                        name="picture"
                        accept="image/*"
                        onChange={handleFileChange}
                        ref={fileInputRef}
                        className="hidden"
                      />
                    </div>
                    <div className="flex flex-col items-center space-y-2 ">
                      <button
                        type="button"
                        onClick={handleButtonClick}
                        className="bg-gexpertise-200 hover:bg-gexpertise-100 text-white font-bold py-3 px-6 rounded-xl focus:outline-none focus:shadow-outline"
                      >
                        Choisir photo
                      </button>
                      <span className=" text-center text-xs py-2 font-semibold text-gray-500">
                        PNG, JPG or JPEG (MAX. 800x400px)
                      </span>
                    </div>
                  </div>
                </div>

                <div className="col-span-3 sm:col-span-3">
                  <label
                    htmlFor="interlocuteur_referent"
                    className="block text-sm font-bold leading-6 text-gray-900"
                  >
                    Interlocuteur référent
                  </label>

                  <Dropdown
                    className="  my-3 border border-gray-300 text-gray-900 font-normal text-xl rounded-lg focus:ring-gexpertise-100 focus:border-gexpertise-200  w-full"
                    value={selectedInterlocuteur}
                    onChange={handleSelectChange}
                    options={options}
                    optionLabel="name"
                    placeholder="Choisir interlocuteur..."
                    showClear
                    filter
                    disabled
                    valueTemplate={selectedInterlocuteurTemplate}
                    itemTemplate={interlocuteurOptionTemplate}
                  />
                </div>
                <div className="col-span-3 sm:col-span-3">
                  <label
                    htmlFor="class_principale_actif"
                    className="block text-sm font-bold leading-6 text-gray-900"
                  >
                    Classe principale
                  </label>
                  <input
                    type="text"
                    name="class_principale_actif"
                    id="class_principale_actif"
                    placeholder="Saisir classe principale"
                    className="  my-3 border border-gray-300 text-gray-900 font-normal text-md rounded-lg focus:ring-gexpertise-100 focus:border-gexpertise-200 block w-full p-2.5 "
                    {...register("class_principale_actif")}
                  />
                </div>


                <div className="col-span-6 sm:col-span-6">
            <label
              htmlFor="Numéro d’avis de taxe foncière"
              className="block text-md font-bold leading-6 text-gray-900"
            >
              Numéro de taxe foncière *
            </label>
            <input
              type="text"
              name="numero_taxe"
              id="numero_taxe"
              placeholder="Saisir numéro de taxe foncière"
              className="  my-3 border border-gray-300 text-gray-900 font-normal text-md rounded-lg focus:ring-gexpertise-100 focus:border-gexpertise-200 block w-full p-2.5 "
              {...register("numero_taxe", {
                required: true,
              })}
            />
          </div>





              </div>
              <div className="border rounded-lg">
                <div className=" w-full max-h-96 overflow-auto space-y-4 mx-10 my-2">
                  <ArborescenceBâtimentaireEditActif
                    site={site}
                    checkbox={true}
                    batimentIds={actif?.bâtiments.map(
                      (batiment) => batiment.id
                    )}
                    niveauIds={actif?.niveaux.map((niveau) => niveau.id)}
                    espaceIds={actif?.espaces.map((espace) => espace.id)}
                    pieceIds={actif?.pieces.map((piece) => piece.id)}
                    setSelectedBâtiments={setSelectedBâtiments}
                    setSelectedNiveaux={setSelectedNiveaux}
                    setSelectedEspaces={setSelectedEspaces}
                    setSelectedPieces={setSelectedPieces}
                    selectedBâtiments={selectedBâtiments}
                    selectedEspaces={selectedEspaces}
                    selectedNiveaux={selectedNiveaux}
                    selectedPieces={selectedPieces}
                  />
                </div>
              </div>
              <p className=" text-lg font-thin my-4">* obligatoire</p>

              <div className="flex justify-end space-x-2 mt-10">
                <button
                  type="submit"
                  className="text-white   bg-gexpertise-200 hover:bg-gexpertise-100 font-medium rounded-lg text-md px-6 py-3  text-center "
                >
                  {loading && (
                    <svg
                      aria-hidden="true"
                      role="status"
                      className="inline w-4 h-4 mr-3 text-white animate-spin"
                      viewBox="0 0 100 101"
                      fill="none"
                      xmlns="http://www.w3.org/2000/svg"
                    >
                      <path
                        d="M100 50.5908C100 78.2051 77.6142 100.591 50 100.591C22.3858 100.591 0 78.2051 0 50.5908C0 22.9766 22.3858 0.59082 50 0.59082C77.6142 0.59082 100 22.9766 100 50.5908ZM9.08144 50.5908C9.08144 73.1895 27.4013 91.5094 50 91.5094C72.5987 91.5094 90.9186 73.1895 90.9186 50.5908C90.9186 27.9921 72.5987 9.67226 50 9.67226C27.4013 9.67226 9.08144 27.9921 9.08144 50.5908Z"
                        fill="#E5E7EB"
                      />
                      <path
                        d="M93.9676 39.0409C96.393 38.4038 97.8624 35.9116 97.0079 33.5539C95.2932 28.8227 92.871 24.3692 89.8167 20.348C85.8452 15.1192 80.8826 10.7238 75.2124 7.41289C69.5422 4.10194 63.2754 1.94025 56.7698 1.05124C51.7666 0.367541 46.6976 0.446843 41.7345 1.27873C39.2613 1.69328 37.813 4.19778 38.4501 6.62326C39.0873 9.04874 41.5694 10.4717 44.0505 10.1071C47.8511 9.54855 51.7191 9.52689 55.5402 10.0491C60.8642 10.7766 65.9928 12.5457 70.6331 15.2552C75.2735 17.9648 79.3347 21.5619 82.5849 25.841C84.9175 28.9121 86.7997 32.2913 88.1811 35.8758C89.083 38.2158 91.5421 39.6781 93.9676 39.0409Z"
                        fill="currentColor"
                      />
                    </svg>
                  )}
                  Modifier
                </button>
                <button
                  type="button"
                  onClick={() => {
                    closeModalEditActif();
                    reset();
                    setSelectedFile(null);
                    setSelectedActif(null);
                  }}
                  className="text-gray-600 border border-gray-600 bg-white hover:bg-gray-100 font-medium rounded-lg text-sm px-6 py-2  text-center "
                >
                  Annuler
                </button>
              </div>
            </form>
          </div>
        </div>
      </CustomDialog>
      {loading && <Loading />}
    </>
  );
};

export default ModalEditActif;
